<template>
    <teleport to="body">
        <div v-if="visible" class="agenda-context-backdrop" :class="{'agenda-context-backdrop--blur': compact}" :style="{zIndex: zBase + 9}" @click.stop="close" @touchend.stop.prevent="close" @contextmenu.stop.prevent="close"></div>
        <div v-if="visible" class="agenda-context-menu" :style="menuStyle" @click.stop @touchend.stop>
            <div class="context-menu-item" @click="handleEdit">
                <span class="context-menu-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </span>
                <span>{{ $t('pages.module.AGENDA.contextMenu.edit') }}</span>
            </div>
            <div class="context-menu-item" :class="{'context-menu-item--disabled': isEventInPast}" @click="!isEventInPast && handleReminder()">
                <span class="context-menu-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                </span>
                <span>{{ hasReminders ? $t('pages.module.AGENDA.contextMenu.editReminder') : $t('pages.module.AGENDA.contextMenu.addReminder') }}</span>
            </div>
            <div v-if="hasReminders" class="context-menu-item" :class="{'context-menu-item--disabled': isEventInPast}" @click="!isEventInPast && handleRemoveReminder()">
                <span class="context-menu-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="1" y1="1" x2="23" y2="23"/><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/></svg>
                </span>
                <span>{{ $t('pages.module.AGENDA.contextMenu.removeReminder') }}</span>
            </div>
            <div class="context-menu-item" @click="handleStatusToggle">
                <span class="context-menu-icon">
                    <svg v-if="event && event.status?.id === 2" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                    <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>{{ event && event.status?.id === 2 ? $t('pages.module.AGENDA.contextMenu.markPending') : $t('pages.module.AGENDA.contextMenu.markCompleted') }}</span>
            </div>
            <div class="context-menu-divider"></div>
            <div class="context-menu-item context-menu-item--danger" @click="handleDelete">
                <span class="context-menu-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                </span>
                <span>{{ $t('pages.module.AGENDA.contextMenu.delete') }}</span>
            </div>
        </div>
    </teleport>
</template>

<script>
export default {
    name: 'AgendaContextMenu',
    props: {
        compact: {type: Boolean, default: false},
        zBase: {type: Number, default: 100000},
    },
    data() {
        return {
            visible: false,
            event: null,
            x: 0,
            y: 0,
        }
    },
    computed: {
        menuStyle() {
            return {
                position: 'fixed',
                left: this.x + 'px',
                top: this.y + 'px',
                zIndex: this.zBase + 10,
            }
        },
        hasReminders() {
            return this.event && this.event.reminders && this.event.reminders.length > 0
        },
        isEventInPast() {
            if (!this.event?.event_at) return false
            return new Date(this.event.event_at.replace(' ', 'T')) < new Date()
        },
    },
    methods: {
        openForEvent(mouseEvent, agendaEvent) {
            this.removeCloseListeners()
            this.event = agendaEvent
            this.setPosition(mouseEvent)
            this.visible = true
            this.addCloseListeners()
        },
        setPosition(event) {
            const menuWidth = 200
            const menuHeight = 220
            let x = event.clientX
            let y = event.clientY
            if (x + menuWidth > window.innerWidth) x = window.innerWidth - menuWidth - 10
            if (y + menuHeight > window.innerHeight) y = window.innerHeight - menuHeight - 10
            this.x = x
            this.y = y
        },
        close() {
            this.visible = false
            this.removeCloseListeners()
        },
        addCloseListeners() {
            setTimeout(() => {
                document.addEventListener('click', this.onDocClick)
                document.addEventListener('touchend', this.onDocClick)
                document.addEventListener('keydown', this.onEsc)
                document.addEventListener('contextmenu', this.onDocContext)
            }, 300)
        },
        removeCloseListeners() {
            document.removeEventListener('click', this.onDocClick)
            document.removeEventListener('touchend', this.onDocClick)
            document.removeEventListener('keydown', this.onEsc)
            document.removeEventListener('contextmenu', this.onDocContext)
        },
        onDocClick() {
            this.close()
        },
        onDocContext() {
            this.close()
        },
        onEsc(e) {
            if (e.key === 'Escape') this.close()
        },
        handleEdit() {
            this.$emit('edit', this.event)
            this.close()
        },
        handleReminder() {
            this.$emit('reminder', this.event)
            this.close()
        },
        handleRemoveReminder() {
            this.$emit('removeReminder', this.event)
            this.close()
        },
        handleStatusToggle() {
            const newStatus = this.event.status?.id === 2 ? 1 : 2
            this.$emit('statusToggle', {id: this.event.id, status_id: newStatus})
            this.close()
        },
        handleDelete() {
            this.$emit('delete', this.event)
            this.close()
        },
    },
    beforeUnmount() {
        this.removeCloseListeners()
    },
}
</script>
